module.exports = __webpack_public_path__ + "static/media/track-applicants.f6958022.png";